import UpdateWatchListEntryPage from './UpdateWatchListEntryPage';

export default UpdateWatchListEntryPage;


// WEBPACK FOOTER //
// ./src/features/watch-list-entry/pages/update-watch-list-entry-page/index.js